import { PureComponent } from "react";
import { LinkToMusicCoversPage, LinkToMusicLivePage } from "../../constants/navUrlConstants";
import CardContainer from "../generic/CardContainer";
import InfoCard from "../generic/InfoCard";
import SubpageToggler from "../generic/SubpageToggler";
import MusicCoversPage from "./MusicCoversPage";
import MusicLivePage from "./MusicLivePage";
import MusicOriginalsPage from "./MusicOriginalsPage";

interface Props {}
interface State {
  selectedPageIndex: number;
}
const OG_SONGS_INDEX = 0;
const COVERS_INDEX = 1;
const LIVES_INDEX = 2;

const subpageOptions = [
  {
    title: "Original Songs",
    index: OG_SONGS_INDEX,
  },
  {
    title: "Fingerstyle Covers",
    index: COVERS_INDEX,
  },
  {
    title: "Live Recordings",
    index: LIVES_INDEX,
  },
];

export default class MusicPage extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedPageIndex: COVERS_INDEX,
    };
  }

  componentDidMount() {
    if (window.location.hash === LinkToMusicLivePage) {
      this.setState({ selectedPageIndex: LIVES_INDEX });
    } else if (window.location.hash === LinkToMusicCoversPage) {
      this.setState({ selectedPageIndex: COVERS_INDEX });
    }
  }

  // Could use this to persist button clicks.  Don't care though, only need deep link when landing.
  // handleSelect = (buttonKey: string) => {
  //   window.location.hash = buttonKey; // could create a LinkCard, but this is more flexible
  // };

  handleSubpageToggle = (index: number) => {
    this.setState({
      selectedPageIndex: index,
    });
  };

  render() {
    const { selectedPageIndex } = this.state;
    return (
      // <CardContainer>
      <InfoCard firstChildIsHeader>
        <SubpageToggler onSelection={this.handleSubpageToggle} options={subpageOptions} selectedIndex={selectedPageIndex} />
        {selectedPageIndex === OG_SONGS_INDEX ? <MusicOriginalsPage /> : null}
        {selectedPageIndex === COVERS_INDEX ? <MusicCoversPage /> : null}
        {selectedPageIndex === LIVES_INDEX ? <MusicLivePage /> : null}
      </InfoCard>
      // </CardContainer>
    );
  }
}
